import React from 'react';
import './Contact.css';

function Contact() {
  return (
    <div className="contact-page">
      <div className="container">
        <h1>Contact Us</h1>
        <p className="contact-intro">
          We'd love to hear from you! Whether you have questions, feedback, or need support, 
          we're here to help.
        </p>

        <section className="contact-info">
          <h2>Get in Touch</h2>
          <div className="contact-methods">
            <div className="contact-method">
              <h3>📧 Email Support</h3>
              <p><strong>Primary Contact:</strong> <a href="mailto:admin@sharespaceapps.com">admin@sharespaceapps.com</a></p>
              <p><strong>Response Time:</strong> Within 24-48 hours</p>
              <p><strong>Best for:</strong> Technical support, account issues, feature requests</p>
            </div>

            <div className="contact-method">
              <h3>📱 In-App Support</h3>
              <p>Use the built-in support feature in the ChapterChat app:</p>
              <p>Profile → Settings → Help & Support → Contact Us</p>
              <p><strong>Best for:</strong> Quick questions, bug reports</p>
            </div>
          </div>
        </section>

        <section className="support-types">
          <h2>What We Can Help With</h2>
          <div className="support-grid">
            <div className="support-item">
              <h3>🔧 Technical Issues</h3>
              <ul>
                <li>App crashes or performance problems</li>
                <li>Login or account access issues</li>
                <li>Data sync problems</li>
                <li>Feature not working as expected</li>
              </ul>
            </div>

            <div className="support-item">
              <h3>👤 Account Management</h3>
              <ul>
                <li>Password reset assistance</li>
                <li>Privacy settings questions</li>
                <li>Account deletion requests</li>
                <li>Data export requests</li>
              </ul>
            </div>

            <div className="support-item">
              <h3>📚 App Features</h3>
              <ul>
                <li>How to use specific features</li>
                <li>Book club management</li>
                <li>Social features and friends</li>
                <li>Reading stats and tracking</li>
              </ul>
            </div>

            <div className="support-item">
              <h3>💡 Feedback & Ideas</h3>
              <ul>
                <li>Feature requests and suggestions</li>
                <li>App improvement ideas</li>
                <li>User experience feedback</li>
                <li>Content and functionality suggestions</li>
              </ul>
            </div>
          </div>
        </section>

        <section className="response-info">
          <h2>Response Times & Expectations</h2>
          <ul>
            <li><strong>Standard Inquiries:</strong> 24-48 hours</li>
            <li><strong>Technical Issues:</strong> 1-3 business days</li>
            <li><strong>Account Problems:</strong> Same day to 24 hours</li>
            <li><strong>Feature Requests:</strong> 3-5 business days (acknowledgment)</li>
          </ul>
          <p>
            <strong>Note:</strong> Response times may be longer during weekends and holidays. 
            We appreciate your patience and will get back to you as soon as possible.
          </p>
        </section>

        <section className="before-contacting">
          <h2>Before You Contact Us</h2>
          <p>To help us assist you more quickly, please:</p>
          <ul>
            <li>Check our <a href="/support">FAQ section</a> for common questions</li>
            <li>Include your device type and iOS version</li>
            <li>Describe the issue in detail with steps to reproduce</li>
            <li>Include screenshots if relevant</li>
            <li>Mention your app version (found in Settings)</li>
          </ul>
        </section>

        <section className="business-info">
          <h2>Business Information</h2>
          <div className="business-details">
            <p><strong>Company:</strong> ShareSpace Apps</p>
            <p><strong>App:</strong> ChapterChat</p>
            <p><strong>Email:</strong> admin@sharespaceapps.com</p>
            <p><strong>Website:</strong> shelfspace.sharespaceapps.com</p>
          </div>
        </section>

        <section className="feedback-form">
          <h2>Quick Feedback</h2>
          <p>
            Love the app? We'd appreciate a review on the App Store! 
            Your feedback helps other readers discover ChapterChat and helps us improve the app.
          </p>
        </section>
      </div>
    </div>
  );
}

export default Contact;